<mat-radio-button [value]="person.personId" color="primary" class="person-selection-item">
    <mat-expansion-panel [expanded]="false" class="person-selection-extension-panel">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <span>{{ person.insuredFullName }}</span>
            </mat-panel-title>
            <mat-panel-description>
                <span class="dhig-label">Date of birth:</span>&nbsp; <b>{{ person.insuredDateOfBirth | dateOnly }}</b>
            </mat-panel-description>
            <mat-panel-description>
                <span class="dhig-label">Citizenship:</span>&nbsp; <b>{{ person.insuredCitizenship }}</b>
            </mat-panel-description>
        </mat-expansion-panel-header>

        <mat-list>
            @if (person.memberIds?.length) {
            <mat-list-item>
                <span class="dhig-label">Member IDs:</span>&nbsp; {{ person.memberIds?.join(', ') }}
            </mat-list-item>
            }
            @if (person.externalIds?.length) {
            <mat-list-item>
                <span class="dhig-label">Alternative IDs:</span>&nbsp; {{ person.externalIds?.join(', ') }}
            </mat-list-item>
            }
        </mat-list>
    </mat-expansion-panel>
</mat-radio-button>